import { render } from "./SvgIcon.vue?vue&type=template&id=3e86034b"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
script.render = render

export default script